module.exports = __webpack_public_path__ + "static/media/search.6a6a62d3.svg";